import { useMutation, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import { ComponentQueryLoader } from '../../../shared/component-query-loader.tsx';
import {
  StaffEntityEditContainerEntityUpdateDocument,
  Entity,
  StaffEntityDetailsContainerEntityDocument,
  EntityUpdateInput} from '../../../../generated.tsx';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityEdit } from './entity-edit.tsx';
import { lookupCountryQuery } from './staff-components-country-query.tsx';
import { Country } from '../../../../types/country.ts';
import { message } from 'antd';

interface EntityEditContainerProps {}

export const EntityEditContainer: React.FC<EntityEditContainerProps> = () => {
  const { entityId } = useParams<{ entityId: string }>();
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();

  const [editEntity] = useMutation(StaffEntityEditContainerEntityUpdateDocument);
  const { data: countryData } = useQuery(lookupCountryQuery);

  const { data, loading, error } = useQuery(StaffEntityDetailsContainerEntityDocument, {
    variables: {
      id: entityId ?? ''
    }
  });

  const onSubmit = async (payload: EntityUpdateInput) => {
    try {
      setIsProcessing(true);
      const response = await editEntity({
        variables: {
          input: payload
        }
      });

      const successStatus = response?.data?.entityUpdate.status.success;
      if (successStatus) {
        message.success('Entity updated successfully.');
        navigate(-1);
      } else {
        message.error('Failed to update the entity: ' + response?.data?.entityUpdate.status.errorMessage);
        setIsProcessing(false);
      }
    } catch (err: any) {
      message.error('Failed to update the entity');
      setIsProcessing(false);
    }
  };

  return (
    <ComponentQueryLoader
      loading={loading}
      hasData={data}
      error={error}
      hasDataComponent={
        <EntityEdit onSubmit={onSubmit} loading={isProcessing} entity={data?.entity as Entity} countryData={countryData?.countries?.eventPayload?.countries as Country[]} />
      }
    />
  );
};
